// extracted by mini-css-extract-plugin
module.exports = {"card":"DeworkTask_card__kUts_"};